import React, { useState, useEffect } from 'react';
import pastWinnersService from '../../services/pastWinnersService';
import './PastWinnersPage.css';

const PastWinnersPage = () => {
  const [pastWinners, setPastWinners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const data = await pastWinnersService.fetchPastWinners();
        setPastWinners(data);
      } catch (err) {
        console.error('Error fetching past winners:', err);
        setError('Failed to load past winners');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="past-winners-page">
        <div className="past-winners-container">
          <div className="past-winners-loading">
            <div className="loading-spinner"></div>
            <p>Loading past winners...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="past-winners-page">
        <div className="past-winners-container">
          <div className="past-winners-error">
            <p>{error}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="past-winners-page">
      <div className="past-winners-container">
        <header className="past-winners-header">
          <h1 className="past-winners-title">Past Winners</h1>
          <p className="past-winners-subtitle">Hall of Champions</p>
        </header>

        {pastWinners.length === 0 ? (
          <div className="past-winners-card">
            <div className="past-winners-card-inner">
              <div className="past-winners-empty">
                <p>No past winners recorded yet.</p>
              </div>
            </div>
          </div>
        ) : (
          <div className="past-winners-card">
            <div className="past-winners-card-inner">
              <div className="past-winners-list">
                {pastWinners.map((winner) => (
                  <div key={winner.pastWinnerId || winner.id} className="past-winner-item">
                    <span className="winner-year">{winner.year}</span>
                    {winner.name && (
                      <>
                        <span className="winner-trophy">🏆</span>
                        <span className="winner-name">{winner.name}</span>
                      </>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PastWinnersPage;
